import React, { useState, useEffect, useMemo } from 'react';
import { X, Award, BookOpen, Mail, Phone, Star, MapPin, Calendar, MessageCircle,Search,Filter,ChevronDown } from 'lucide-react';
import { useTutoresModel } from '../../../modelos/Tutores/modeloTutores';
import { useNavigate } from 'react-router-dom';
import { useConfiguracion } from '../../../metodos/ConfiguracionContext';

//toca meterle parametros de url para guardar estados
const ListaTutores = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [showFilters, setShowFilters] = useState(false);
  const [selectedFilters, setSelectedFilters] = useState({
    materias: [],
    carreras: [],
    servicios: [],
    universidad: '',
    estado: 'Todos',
    precioMin: '',
    precioMax: '',
    rating: ''
  });
  const navigate = useNavigate();
  const [rolSeleccionado, setRolSeleccionado] = useState('TUTOR');
  const {configuracion, loadingConfiguracion} = useConfiguracion();

  const {
    tutores,
    loadingTUtores,
    errorTutores,
    cargarTutores,
    //prospectos
    cargarProspectos,
    prospectos,
    //colaboradores
    cargarColaboradores,
    colaboradores,
  } = useTutoresModel();

  useEffect(() => {
    console.log(`Cargando datos para: ${rolSeleccionado}`);
    switch (rolSeleccionado) {
      case 'TUTOR':
        // Aquí llamas a la función que obtiene los tutores desde la API
        cargarTutores(); 
        break;
      case 'PROSPECTO':
        // Debes crear esta función en tu modelo para llamar a la API de prospectos
        cargarProspectos();
        break;
      case 'ADMIN':
        cargarColaboradores(configuracion.nombreEmpresa);
        break;
      default:
        cargarTutores();
    }
  }, [rolSeleccionado]); 

  const tutoresArray = useMemo(() => { // <-- ESTE ES EL HOOK QUE SE MOVIÓ
    switch (rolSeleccionado) {
      case 'TUTOR': return tutores || [];
      case 'PROSPECTO': return prospectos || [];
      case 'ADMIN': return colaboradores || [];
      default: return [];
    }
  }, [rolSeleccionado, tutores, prospectos, colaboradores]);

  if (loadingTUtores) {
    return (
      <div className="bg-white rounded-lg shadow-lg p-8 max-w-4xl mx-auto flex flex-col items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500 mb-4"></div>
        <p className="text-gray-600">Cargando tutores...</p>
      </div>
    );
  }

  //TENEMOS ROLES
  //COLABORADOR - ADMIN
  //TUTOR
  //PROSPECTO
  

  // Materias extraidas de tutores
  const materias = [...new Set(tutoresArray.flatMap(tutor => 
    tutor.materias ? tutor.materias.map(m => m.nombremateria) : []
  ))].filter(Boolean);

  //carreras extraidos de tutoires
  const carreras = [...new Set(tutoresArray.map(tutor => tutor.carrera).filter(Boolean))];
  
  //tipos de servicios extraidos
  const tiposServicios = [...new Set(tutoresArray.flatMap(tutor => 
    tutor.tipoServicios || []
  ))].filter(Boolean);
  
  //universdades
  const universidades = [...new Set(tutoresArray.map(tutor => tutor.universidad).filter(Boolean))];

  
  const handleFilterChange = (filterType, value, isMultiple = false) => {
    if (isMultiple) {
      setSelectedFilters(prev => ({
        ...prev,
        [filterType]: prev[filterType].includes(value)
          ? prev[filterType].filter(item => item !== value)
          : [...prev[filterType], value]
      }));
    } else {
      setSelectedFilters(prev => ({
        ...prev,
        [filterType]: value
      }));
    }
  };

  const clearFilters = () => {
    setSelectedFilters({
      materias: [],
      carreras: [],
      servicios: [],
      universidad: '',
      estado: 'Todos',
      precioMin: '',
      precioMax: '',
      rating: ''
    });
  };

  // Filtrar tutores
  const filteredTutors = tutoresArray.filter(tutor => {
    if (!tutor) return false;

    const matchesSearch = !searchTerm || 
      (tutor.nombrewhatsapp && tutor.nombrewhatsapp.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (tutor.carrera && tutor.carrera.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (tutor.universidad && tutor.universidad.toLowerCase().includes(searchTerm.toLowerCase()));

    const matchesMaterias = selectedFilters.materias.length === 0 || 
      (tutor.materias && selectedFilters.materias.some(materia => 
        tutor.materias.some(m => (m.nombremateria ).includes(materia))
      ));

    const matchesCarreras = selectedFilters.carreras.length === 0 ||
      selectedFilters.carreras.includes(tutor.carrera);

    const matchesServicios = selectedFilters.servicios.length === 0 ||
      (tutor.tipoServicios && selectedFilters.servicios.some(servicio => 
        tutor.tipoServicios.includes(servicio)
      ));

    const matchesUniversidad = !selectedFilters.universidad || tutor.universidad === selectedFilters.universidad;

    const matchesEstado = selectedFilters.estado === 'Todos' || 
      (selectedFilters.estado === 'Activo' && tutor.activo) ||
      (selectedFilters.estado === 'Inactivo' && !tutor.activo);

    return matchesSearch && matchesMaterias && matchesCarreras && matchesServicios && matchesUniversidad && matchesEstado;
  });

  const FilterSection = ({ title, items, filterKey, isMultiple = true }) => (
    <div className="mb-4">
      <h4 className="font-semibold text-gray-700 mb-2">{title}</h4>
      <div className="space-y-2 max-h-40 overflow-y-auto">
        {items.map((item, index) => (
          <label key={index} className="flex items-center space-x-2 cursor-pointer">
            <input
              type={isMultiple ? "checkbox" : "radio"}
              name={filterKey}
              checked={isMultiple ? selectedFilters[filterKey].includes(item) : selectedFilters[filterKey] === item}
              onChange={() => handleFilterChange(filterKey, item, isMultiple)}
              className="text-blue-600 focus:ring-blue-500 rounded"
            />
            <span className="text-sm text-gray-600">{item}</span>
          </label>
        ))}
      </div>
    </div>
  );

  const TutorCard = ({ tutor }) => {
    if (!tutor) return null;

    return (
      <div className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100 overflow-hidden group">
        <div className="relative">
          <div className="h-32 bg-gradient-to-br from-blue-600 via-purple-600 to-blue-800"></div>
          {/* Foto de perfil */}
          <div className="absolute -bottom-10 left-6">
             
             
            <div className="relative">
              <img 
                src={tutor.fotoPerfil || `https://ui-avatars.com/api/?name=${encodeURIComponent(tutor.nombreCompleto || 'Usuario')}&background=3b82f6&color=fff&size=80`}
                alt={tutor.nombreCompleto}
                className="w-20 h-20 rounded-full border-4 border-white shadow-xl object-cover"
                onError={(e) => {
                  e.target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(tutor.nombreCompleto || 'Usuario')}&background=3b82f6&color=fff&size=80`;
                }}
              />
              {tutor.tutorVerificado && (
                <div className="absolute -top-1 -right-1 bg-green-500 rounded-full p-1">
                  <Award className="w-4 h-4 text-white" />
                </div>
              )}
            </div>

          </div>

          {/* Badge de tutor activo / inactivo */}
          <div className="absolute top-4 right-4 flex gap-2">
            <span className={`px-3 py-1 rounded-full text-xs font-semibold ${
              tutor.activo 
                ? 'bg-green-100 text-green-800' 
                : 'bg-red-100 text-red-800'
            }`}>
              {tutor.activo ? 'Activo' : 'Inactivo'}
            </span>
          </div>

        </div>
        
        <div className="pt-12 pb-6 px-6">
          <h3 className="font-bold text-xl text-gray-900 mb-1">
            {tutor.nombreCompleto || 'Sin nombre'}
          </h3>

          {tutor.nombreEmpresa} empresa

          <p className="text-blue-600 font-medium text-sm mb-1">
            {tutor.carrera || 'Sin carrera'}
          </p>

          <p className="text-gray-500 text-xs mb-3">
            {tutor.universidad || 'Sin universidad'}
          </p>
          
          <div className="space-y-3 mb-4">
            <div className="flex items-center text-sm text-gray-600">
              <BookOpen className="w-4 h-4 mr-2 text-blue-500" />
              <span>{tutor.materias ? tutor.materias.length : 0} materias</span>
            </div>
            <div className="flex items-center text-sm text-gray-600">
              <Mail className="w-4 h-4 mr-2 text-green-500" />
              <span className="truncate">{tutor.correogmail || 'Sin email'}</span>
            </div>
            <div className="flex items-center text-sm text-gray-600">
              <Phone className="w-4 h-4 mr-2 text-purple-500" />
              <span>{tutor.numeroWhatsapp || 'Sin teléfono'}</span>
            </div>
          </div>

          
          <div className="flex gap-2">
            
            <button 
            onClick={() => navigateToDetalles(tutor.uid,tutor.nombreEmpresa)}
            className="flex-1 bg-blue-600 hover:bg-blue-700 text-white py-3 px-4 rounded-xl transition-colors duration-200 flex items-center justify-center font-semibold">
              <Phone className="w-4 h-4 mr-2" />
              Ver Detalles
            </button>

          </div>

        </div>
      </div>
    );

  };

  const statsTutores ={
    total: tutoresArray.filter(tutor => tutor.rol == "TUTOR").length,
    tutoresActivos: tutoresArray.filter(tutor => tutor.activo && tutor.rol == "TUTOR").length,
    tutoresInactivos: tutoresArray.filter(tutor => !tutor.activo && tutor.rol == "TUTOR").length,
    tutoresExpulsados: tutoresArray.filter(tutor => tutor.expulsado && tutor.rol == "TUTOR").length,
  }

  const navigateToDetalles = (uidTutor,nombreEmpresa) =>{
    const empresa = nombreEmpresa;
    navigate(`/tutores/detalles_tutor/${empresa}/${uidTutor}`);
  }

  if (errorTutores) {
    return (
      <div className="bg-white rounded-lg shadow-lg p-8 max-w-4xl mx-auto flex flex-col items-center justify-center min-h-screen">
        <div className="bg-red-50 border border-red-200 rounded-lg p-6 w-full max-w-md">
          <h3 className="text-red-800 font-semibold mb-2">Error al cargar tutores</h3>
          <p className="text-red-700 mb-4">{errorTutores}</p>
          <button
            onClick={cargarTutores}
            className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded transition-colors"
          >
            Reintentar
          </button>
        </div>
      </div>
    );
  }

  return (
  <div className="min-h-screen bg-gray-50">
    {/* Header Principal Compacto */}
    <div className="bg-white border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-6 py-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-4">
            <div>
              {/* Título dinámico */}
              <h1 className="text-lg font-semibold text-gray-900">
                Gestión de tutores
              </h1>
              <p className="text-xs text-gray-500">Vista completa del sistema</p>
            </div>
            
            {/* === AQUÍ VAN LOS NUEVOS BOTONES === */}
            <div className="flex items-center bg-gray-100 p-1 rounded-lg">
              <button
                onClick={() => setRolSeleccionado('TUTOR')}
                className={`px-3 py-1 text-sm font-medium rounded-md transition-all ${
                  rolSeleccionado === 'TUTOR' ? 'bg-white shadow-sm text-blue-600' : 'text-gray-600 hover:text-black'
                }`}
              >
                Tutores
              </button>
              <button
                onClick={() => setRolSeleccionado('PROSPECTO')}
                className={`px-3 py-1 text-sm font-medium rounded-md transition-all ${
                  rolSeleccionado === 'PROSPECTO' ? 'bg-white shadow-sm text-blue-600' : 'text-gray-600 hover:text-black'
                }`}
              >
                Prospectos
              </button>
              <button
                onClick={() => setRolSeleccionado('ADMIN')}
                className={`px-3 py-1 text-sm font-medium rounded-md transition-all ${
                  rolSeleccionado === 'ADMIN' ? 'bg-white shadow-sm text-blue-600' : 'text-gray-600 hover:text-black'
                }`}
              >
                Colaboradores
              </button>
            </div>
            {/* ===================================== */}

          </div>
          {/* ... el resto de tu header ... */}
        </div>
      </div>
    </div>

    <div className="max-w-7xl mx-auto px-6 py-4">
      {/* Barra de Filtros Compacta */}
      <div className="bg-white rounded-lg border border-gray-200 mb-4">
        <div className="p-4">
          {/* Primera fila - Filtros principales */}
          <div className="flex flex-wrap items-center gap-2 mb-3">
            <button
              onClick={() => handleFilterChange('estado', 'Todos')}
              className={`px-3 py-1.5 rounded text-sm font-medium transition-all ${
                selectedFilters.estado === 'Todos' 
                  ? 'bg-gray-700 text-white' 
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              Todas ({statsTutores.total})
            </button>

            <button
              onClick={() => handleFilterChange('estado', 'Activo')}
              className={`px-3 py-1.5 rounded text-sm font-medium transition-all ${
                selectedFilters.estado === 'Activo' 
                  ? 'bg-green-600 text-white' 
                  : 'bg-green-100 text-green-700 hover:bg-green-200'
              }`}
            >
              ✓ Disponibles ({statsTutores.tutoresActivos})
            </button>

            <button
              onClick={() => handleFilterChange('estado', 'Inactivo')}
              className={`px-3 py-1.5 rounded text-sm font-medium transition-all ${
                selectedFilters.estado === 'Inactivo' 
                  ? 'bg-orange-600 text-white' 
                  : 'bg-orange-100 text-orange-700 hover:bg-orange-200'
              }`}
            >
              ⏸ Inactivos ({statsTutores.tutoresInactivos})
            </button>

            {/* Segunda fila - Búsqueda y filtros avanzados 
            {statsTutores.tutoresExpulsados > 0 && (
              <button
                onClick={() => handleFilterChange('estado', 'Expulsado')}
                className={`px-3 py-1.5 rounded text-sm font-medium transition-all ${
                  selectedFilters.estado === 'Expulsado' 
                    ? 'bg-red-600 text-white' 
                    : 'bg-red-100 text-red-700 hover:bg-red-200'
                }`}
              >
                ⚠ Expulsados ({statsTutores.tutoresExpulsados})
              </button>
              
            )}
              */}

          </div>

          {/* Segunda fila - Búsqueda y filtros avanzados */}
          <div className="flex flex-col lg:flex-row gap-3">
            <div className="flex-1 relative">
              <Search className="absolute left-3 top-2.5 h-4 w-4 text-gray-400" />
              <input
                type="text"
                placeholder="Buscar..."
                className="w-full pl-9 pr-4 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            
            <div className="flex items-center space-x-2">
              {/* Filtros rápidos */}
              {materias.length > 0 && (
                <select 
                  className="px-3 py-2 border border-gray-200 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  onChange={(e) => handleFilterChange('materias', e.target.value ? [e.target.value] : [], true)}
                >
                  <option value="">Materias</option>
                  {materias.slice(0, 10).map((materia, index) => (
                    <option key={index} value={materia}>{materia}</option>
                  ))}
                </select>
              )}

              {universidades.length > 0 && (
                <select 
                  className="px-3 py-2 border border-gray-200 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  value={selectedFilters.universidad}
                  onChange={(e) => handleFilterChange('universidad', e.target.value)}
                >
                  <option value="">Universidad</option>
                  {universidades.map((uni, index) => (
                    <option key={index} value={uni}>{uni}</option>
                  ))}
                </select>
              )}

              <button
                onClick={() => setShowFilters(!showFilters)}
                className={`flex items-center gap-1 px-3 py-2 rounded-lg border text-sm font-medium transition-colors ${
                  showFilters ? 'bg-blue-50 text-blue-700 border-blue-200' : 'bg-white text-gray-700 border-gray-200 hover:bg-gray-50'
                }`}
              >
                <Filter className="w-4 h-4" />
                Filtros
                <ChevronDown className={`w-3 h-3 transition-transform ${showFilters ? 'rotate-180' : ''}`} />
              </button>

              {(selectedFilters.materias.length > 0 || selectedFilters.carreras.length > 0 || selectedFilters.servicios.length > 0 || selectedFilters.universidad) && (
                <button
                  onClick={clearFilters}
                  className="text-red-600 hover:text-red-700 p-2 rounded-lg hover:bg-red-50 transition-colors"
                  title="Limpiar filtros"
                >
                  <X className="w-4 h-4" />
                </button>
              )}
            </div>
          </div>

          {/* Panel de filtros expandido */}
          {showFilters && (
            <div className="mt-4 pt-4 border-t border-gray-100">
              <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-4">
                <div>
                  <FilterSection title="Materias" items={materias} filterKey="materias" />
                </div>
                <div>
                  <FilterSection title="Carreras" items={carreras} filterKey="carreras" />
                </div>
                <div>
                  <FilterSection title="Servicios" items={tiposServicios} filterKey="servicios" />
                </div>
                
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Información de resultados compacta */}
      <div className="flex items-center justify-between mb-4 text-sm text-gray-600">
        <div>
          Mostrando <span className="font-semibold text-blue-600">{filteredTutors.length}</span> de <span className="font-semibold">{tutoresArray.length}</span> tutores
          {searchTerm && <span className="text-gray-500"> • "{searchTerm}"</span>}
        </div>
        
      </div>

      {/* Grid de tutores */}
      {filteredTutors.length > 0 ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
          {filteredTutors.map((tutor, index) => (
            <TutorCard key={tutor.uid || tutor.id || index} tutor={tutor} />
          ))}
        </div>
      ) : (
        <div className="text-center py-12">
          <div className="bg-white rounded-lg p-8 max-w-md mx-auto border border-gray-200">
            <Search className="mx-auto h-12 w-12 text-gray-400 mb-4" />
            <h3 className="text-lg font-medium text-gray-900 mb-2">No se encontraron tutores</h3>
            <p className="text-gray-600 mb-4 text-sm">
              {tutoresArray.length === 0 
                ? "No hay tutores registrados en el sistema." 
                : "Intenta ajustar los filtros o términos de búsqueda."
              }
            </p>
            {tutoresArray.length > 0 && (
              <button
                onClick={clearFilters}
                className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg transition-colors text-sm font-medium"
              >
                Limpiar Filtros
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  </div>
);

};

export default ListaTutores;